import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '~/hooks/useAppSelector';
import { apiMethodsConst } from '~/services/methods';
import { UpdateOfficeService } from '../services/UpdateOfficeService';
import type { IUpdateOfficeRequest } from '../types/UpdateOffice';

export const useUpdateOffice = () => {
  const dispatch = useDispatch();
  const currentUser = useAppSelector((state) => state.user?.user ?? null);

  return useMutation<
    Awaited<ReturnType<typeof UpdateOfficeService.updateOffice>>,
    unknown,
    IUpdateOfficeRequest
  >({
    mutationFn: (payload) => UpdateOfficeService.updateOffice(payload),
    onSuccess: (result, { officeName, officeType, officeSpecialty }) => {
      if (!currentUser?.id) return;

      // Prefer the BE-echoed address (carries normalized fields the client
      // can't synthesize). Keep the existing address when no address call
      // was made.
      const nextAddress = result.address ? [result.address] : currentUser.address;

      dispatch({
        type: apiMethodsConst.EDIT_USER_REQUEST,
        payload: {
          ...currentUser,
          office_name: officeName,
          address: nextAddress,
          office_info: {
            ...(currentUser.office_info ?? {}),
            officeType,
            officeSpecialty,
          },
        },
      });
    },
  });
};
